module.exports = __webpack_public_path__ + "5d35a3f6d6393f676eaa2035293a0a00.ico";